export default "__VITE_ASSET__DdNS0WYX__"